import { useLocation, useNavigate } from 'react-router-dom';

const MAPS_URL =
  'https://www.google.com/maps/dir/?api=1&destination=Cvetkovci%2050%2C%202273%20Podgorci';

const homeLinks = [
  { id: 'domov', label: 'DOMOV' },
  { id: 'o-nas', label: 'O NAS' },
  { id: 'ponudba', label: 'PONUDBA' },
  { id: 'galerija', label: 'GALERIJA' },
  { id: 'kontakt', label: 'KONTAKT' },
];

const roomLinks = [
  { id: 'sobe', label: 'SOBE' },
  { id: 'oprema', label: 'OPREMA SOB' },
  { id: 'galerija', label: 'GALERIJA SOB' },
  { id: 'booking', label: 'REZERVACIJA' },
];

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const isRooms = location.pathname.startsWith('/sobe');
  const links = isRooms ? roomLinks : homeLinks;

  const goTo = (id: string) => {
    if (isRooms) {
      navigate('/gostilna');
      window.setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 120);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-background-900 py-12 md:py-16">
      <div className="w-full px-5 md:px-10 lg:px-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 mb-10 md:mb-14">
            <div>
              <span className="font-heading text-xl md:text-2xl font-semibold text-white mb-3 block">
                Gostilna Marta
              </span>
              <p className="font-heading text-base md:text-lg italic text-white/50 mb-4">
                Domača kuhinja, pristno gostoljubje.
              </p>
              <p className="font-body text-sm text-white/40 leading-relaxed">
                Cvetkovci 50
                <br />
                2273 Podgorci
                <br />
                Slovenija
              </p>
              <div className="flex gap-2 mt-5">
                <button
                  onClick={() => {
                    navigate('/gostilna');
                    window.scrollTo({ top: 0 });
                  }}
                  className={`inline-flex items-center gap-2 px-4 py-2 rounded-full font-label text-[11px] font-medium tracking-wide transition-all duration-300 cursor-pointer ${
                    !isRooms
                      ? 'bg-primary-500 text-background-950'
                      : 'bg-white/[0.06] text-white/50 hover:text-accent-400'
                  }`}
                >
                  <i className="ri-restaurant-2-line"></i>
                  GOSTILNA
                </button>
                <button
                  onClick={() => {
                    navigate('/sobe');
                    window.scrollTo({ top: 0 });
                  }}
                  className={`inline-flex items-center gap-2 px-4 py-2 rounded-full font-label text-[11px] font-medium tracking-wide transition-all duration-300 cursor-pointer ${
                    isRooms
                      ? 'bg-primary-500 text-background-950'
                      : 'bg-white/[0.06] text-white/50 hover:text-accent-400'
                  }`}
                >
                  <i className="ri-hotel-bed-line"></i>
                  SOBE
                </button>
              </div>
            </div>

            <div>
              <p className="font-label text-xs tracking-extra-wide text-accent-500 font-medium uppercase mb-4">
                {isRooms ? 'Nastanitev' : 'Navigacija'}
              </p>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.id}>
                    <a
                      href={`#${link.id}`}
                      onClick={(e) => {
                        e.preventDefault();
                        goTo(link.id);
                      }}
                      className="font-body text-sm text-white/50 hover:text-accent-400 transition-colors duration-300 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
                {!isRooms && (
                  <li>
                    <a
                      href="/sobe"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate('/sobe');
                        window.scrollTo({ top: 0 });
                      }}
                      className="font-body text-sm text-accent-400 hover:text-accent-300 transition-colors duration-300 cursor-pointer"
                    >
                      SOBE IN PRENOČIŠČA
                    </a>
                  </li>
                )}
              </ul>
            </div>

            <div>
              <p className="font-label text-xs tracking-extra-wide text-accent-500 font-medium uppercase mb-4">
                Sledi nam
              </p>
              <div className="flex gap-3 mb-6">
                <a
                  href="https://www.facebook.com/GostilnaMarta"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  aria-label="Facebook"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-accent-500/20 text-white/50 hover:text-accent-400 transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-facebook-fill"></i>
                </a>
              </div>
              <div className="space-y-2 mb-6">
                <a
                  href="tel:+38627130060"
                  className="flex items-center gap-2 font-body text-sm text-white/40 hover:text-accent-400 transition-colors duration-300 cursor-pointer"
                >
                  <i className="ri-phone-line"></i>
                  <span>02 713 00 60</span>
                </a>
                <a
                  href="tel:+38641331990"
                  className="flex items-center gap-2 font-body text-sm text-white/40 hover:text-accent-400 transition-colors duration-300 cursor-pointer"
                >
                  <i className="ri-smartphone-line"></i>
                  <span>041 331 990</span>
                </a>
              </div>
              <div className="font-body text-sm text-white/40 mb-2 space-y-0.5">
                <p>Pon–Čet 06:30–23:00</p>
                <p>Pet–Sob 06:30–01:00</p>
                <p>Ned zaprto</p>
              </div>
              <a
                href={MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-5 py-2.5 border border-white/20 hover:border-accent-400 text-white/70 hover:text-accent-400 text-xs font-label font-medium tracking-wide transition-all duration-300 whitespace-nowrap rounded-sm cursor-pointer"
              >
                <i className="ri-map-pin-line"></i>NAVODILA ZA POT
              </a>
            </div>
          </div>

          <div className="border-t border-white/10 pt-6 md:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="font-body text-xs text-white/30">
              &copy; {new Date().getFullYear()} Gostilna Marta. Vse pravice pridržane.
            </p>
            <a
              href="https://www.facebook.com/GostilnaMarta"
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label="Facebook – Gostilna Marta"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-white/[0.06] hover:bg-accent-500/20 text-white/50 hover:text-accent-400 font-label text-xs font-medium tracking-wide transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-facebook-circle-fill text-base"></i>
              ZAPELJI NAS NA FACEBOOKU
            </a>
            <p className="font-body text-xs text-white/30">DOMAČA KUHINJA. GOSTOLJUBJE. TRADICIJA.</p>
          </div>

          <div className="mt-8 md:mt-10 pt-6 md:pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-center gap-5 md:gap-8">
            <div className="h-12 md:h-14 flex items-center justify-center rounded-md bg-white px-3 py-1.5">
              <img
                src="https://storage.helloreaddy.io/project_files/1fc772e2-8e3a-4f70-9a3e-eb29813d715f/3c513672-0b29-42d9-b0d6-0b36a684e095_compressed_green_key_logo.webp"
                alt="Green Key – okoljsko odgovorna nastanitev"
                title="Green Key certifikat – Gostilna Marta"
                className="h-full w-auto object-contain"
              />
            </div>
            <div className="h-12 md:h-14 flex items-center justify-center rounded-md bg-white px-3 py-1.5">
              <img
                src="https://storage.helloreaddy.io/project_files/1fc772e2-8e3a-4f70-9a3e-eb29813d715f/aef2275d-2993-4926-bbb7-b4dfed37a14d_compressed_evropska_unija_logo.webp"
                alt="Evropska unija – Evropski sklad za regionalni razvoj"
                title="Evropska unija – Evropski sklad za regionalni razvoj – Gostilna Marta"
                className="h-full w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}